import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';

interface BlogLayoutProps {
  children: React.ReactNode;
  wide?: boolean;
}

export default function BlogLayout({ children, wide = false }: BlogLayoutProps) {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      <main className={`${wide ? 'max-w-7xl' : 'max-w-5xl'} mx-auto px-4 pb-16 pt-28 sm:px-6 sm:pt-32 lg:px-8`}>
        {children}
      </main>

      <footer className="border-t border-slate-200 bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-center">
            <div className="flex items-center gap-4">
              <img
                src="/images/linus-tse-linkedin-photo.jpeg"
                alt="Linus Tse"
                className="h-14 w-14 rounded-full object-cover ring-4 ring-white"
              />
              <div>
                <p className="font-semibold text-slate-950">Written from the work</p>
                <p className="mt-1 max-w-xl text-sm text-slate-600">Practical notes from Linus Tse on building, fixing, and operating modern data systems.</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm font-semibold text-[#1a4e94]">
              <a href="mailto:linus@greyfielddata.com" className="hover:text-slate-950">Email Linus</a>
              <a href="https://www.linkedin.com/in/linustse/" target="_blank" rel="noopener noreferrer" className="hover:text-slate-950">LinkedIn</a>
              <a href="https://linustse.com" target="_blank" rel="noopener noreferrer" className="hover:text-slate-950">linustse.com</a>
            </div>
          </div>
          <nav aria-label="Data consulting services" className="mt-6 flex flex-wrap gap-x-5 gap-y-2 border-t border-slate-200 pt-6 text-sm font-semibold text-[#1a4e94]">
            <Link to="/services/snowflake-consulting" className="hover:text-slate-950">Snowflake consulting</Link>
            <Link to="/services/sigma-consulting" className="hover:text-slate-950">Sigma consulting</Link>
            <Link to="/ecommerce" className="hover:text-slate-950">Ecommerce data warehouses</Link>
            <Link to="/case-studies" className="hover:text-slate-950">Client case studies</Link>
            <Link to="/compare" className="hover:text-slate-950">Tool comparisons</Link>
            <Link to="/resources" className="hover:text-slate-950">Guides and tools</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
